import axios from 'axios'
import {asResponse} from '../util'


export const sendHelpRequest = async (params) => {
  return asResponse(axios.post('/bff/help/send-request', params))
}

